import type { MeetingState } from "@odingard/sdk-client";

const labels: Record<string, string> = {
  DRAFT: "Draft",
  IN_REVIEW: "In review",
  ADOPTED: "Adopted",
  SEALED: "Sealed",
  ABANDONED: "Abandoned",
  PENDING: "Pending review",
  CONFIRMED: "Confirmed",
  REJECTED: "Rejected",
  SUPERSEDED: "Superseded",
  COMPLETE: "Complete",
  CANCELLED: "Cancelled",
  OPEN: "Open",
  DUE_SOON: "Due soon",
  OVERDUE: "Overdue",
  SUCCEEDED: "Completed",
  FAILED_CLOSED: "Could not answer safely",
  EMPTY: "No grounded result",
  INTERNAL: "Internal attendee",
  EXTERNAL: "External attendee",
};

export function meetingLabel(value: string): string {
  return labels[value] ?? value.replaceAll("_", " ").toLowerCase().replace(/^\w/, (letter) => letter.toUpperCase());
}

export function stateTone(state: MeetingState): "neutral" | "info" | "success" | "warning" {
  if (state === "SEALED" || state === "ADOPTED") return "success";
  if (state === "IN_REVIEW") return "warning";
  return "neutral";
}

export function DemoNotice({ demoMode }: { demoMode: boolean }) {
  if (!demoMode) return null;
  return (
    <div className="ods-failclosed" role="status">
      <strong>Demo data.</strong> Meeting AI is using deterministic fixtures; nothing shown is a governed production record.
    </div>
  );
}

export function WorkItemLabel({ type }: { type: string }) {
  const labels: Record<string, string> = {
    "meeting.candidates_awaiting_confirmation": "Candidates awaiting confirmation",
    "meeting.minutes_awaiting_adoption": "Minutes awaiting adoption",
    "meeting.commitment_due_soon": "Commitment due soon",
    "meeting.commitment_overdue": "Commitment overdue",
  };
  return <>{labels[type] ?? "Meeting AI governed work"}</>;
}
